export const SWITCH_TAB = 'SWITCH_TAB';
export const SUBMIT_CIGARETTE = 'SUBMIT_CIGARETTE';
export const SEND_PAGEVIEW = 'SEND_PAGEVIEW';
